import Media from "./../mediaDetect.js"; //Детектор медиа
import TypicalSlider from "./typical-slider.js";
import Tabs from "./tabs.js";
import TableScroll from "./table-scroll.js";
import Twig from "twig";

window.hashIE = {}
function hashIE (f) {
  window.hashIE.oldURL = window.location.href

  window.addEventListener('hashchange', function (e) {
    window.hashIE.newURL = window.location.href
    f(e)
  })
}

var mapNav = function() {
  var touchDevice = false;
  var currMaxrix = [];
  var timeoutOpenPopup = 300;
  var it = this;
  var timeoutAjaxPavilion;
  var timeoutAjaxConferenceHalls;
  var timeoutAjaxAdvertisingConstructions;

  var globalScale = 2,
      globalScaleText = 1.6,
      minScaleIcons = 0.7,
      clearTimeIcons,
      isUpdateHash = true,
      isUpdateValueSelectizePanel = true;

  this.hashChangeEvent = function() {
    hashIE(function (e) {
      if(!isUpdateHash && Media.detect().isMobile) {
        isUpdateHash = true;
        return;
      }

      var oldURL = e.oldURL ? e.oldURL : window.hashIE.oldURL
      var newURL = e.newURL ? e.newURL : window.hashIE.newURL
      // получаем старый и новый хэш из УРЛов
      var oldHash = it.getHashFromURL(oldURL);
      var newHash = it.getHashFromURL(newURL);
      // получаем объекты из хэша с которого переходим и того, на который переходим
      var oldHashObj = it.getObjFromHash(oldHash);
      var newHashObj = it.getObjFromHash(newHash);

      // если новый хэш есть, то передаем объекты в контроллер
      if (newHashObj) {
        it.eventController(oldHashObj, newHashObj);
      // если нет, то сбрасываем состояние карты
      } else {
        let oldCategory = $("[data-tcomplex]").find("[data-item-category-tcomplex].active"),
            valOldCategory = oldCategory.data("item-category-tcomplex");

        it.closePopup($("[data-tcomplex]"));
        $('[data-infrastructure-tcomplex]').removeClass('active');
        $('[data-advertising-constructions-tcomplex]').removeClass('active');
        $('.active[data-item-category-tcomplex]').removeClass('active');
        $('.active[data-type-subcategory-tcomplex]').removeClass('active');
        $('.active[data-type-subcategory-tcomplex]').closest('.subcategory').hide();
        $("[data-map-tcomplex]").removeClass("category-" + valOldCategory);
      }
    })
    // Обрабатываем события изменения хэша
    // window.addEventListener("hashchange", function(e) {
    //   let oldURL = e.oldURL
    //   let newURL = e.newURL
    //   // получаем старый и новый хэш из УРЛов
    //   let oldHash = it.getHashFromURL(oldURL);
    //   let newHash = it.getHashFromURL(newURL);
    //   // получаем объекты из хэша с которого переходим и того, на который переходим
    //   let oldHashObj = it.getObjFromHash(oldHash);
    //   let newHashObj = it.getObjFromHash(newHash);
    //
    //   // если новый хэш есть, то передаем объекты в контроллер
    //   if (newHashObj) {
    //     it.eventController(oldHashObj, newHashObj);
    //   // если нет, то сбрасываем состояние карты
    //   } else {
    //     it.closePopup($("[data-tcomplex]"));
    //   }
    // });
  };

  this.eventController = function(oldObj, newObj) {
    // если есть в новом хэше павильон, то грузим этот павильон
    if (newObj.pavilion && !newObj.conference_hall && !newObj.adv_construction) {
      var level = newObj["level"] ? ('[id*="level-' + newObj["level"] + '"]') : '';
      this.ajaxPavilion($('[id*="pavilion-' + newObj["pavilion"] + '-"]'));
      // если есть категории и субкатегории фильтров, то отображаем фильтры
    }

    if (newObj.category && newObj.subcategory) {
      let fBtnParent = $(
        '[data-item-category-tcomplex="' + newObj["category"] + '"]'
      )[0];

      $('[id*="filter_category-' + newObj.category + '"]').removeClass(
        "active"
      );

      it.setActiveCategoryFilter(
        $($(fBtnParent).find(".item-category-tcomplex__title")[0]),
        false
      );

      newObj.subcategory.forEach(function(sub) {
        // if (
        //   $(fBtnParent)
        //     .find(".subcategory")
        //     .is(":visible")
        // ) {
          it.showSubcategory(fBtnParent, sub);
        // } else {
        //   it.setActiveCategoryFilter(
        //     $($(fBtnParent).find(".item-category-tcomplex__title")[0]),
        //     false
        //   );
          // it.showSubcategory(fBtnParent, sub);
        // }
      });

      if(newObj.adv_construction) {
        let advertisingConstructions = $('[data-advertising-constructions-tcomplex="' + newObj.adv_construction + '"]');
        it.ajaxAdvertisingConstructions(advertisingConstructions);
      }
    // если есть только категории, то отображаем их
    } else if (newObj.category && !newObj.subcategory && !newObj.adv_construction) {
      let fBtn = $(
        '[data-item-category-tcomplex="' + newObj["category"] + '"]'
      ).find(".item-category-tcomplex__title")[0];
      this.setActiveCategoryFilter($(fBtn));
      // если в хэше есть конференц-залы, то грузим попап с ними
      if (newObj["conference_hall"]) {
        let currEl = $('#' + newObj["conference_hall"]);

        this.ajaxConferenceHalls(currEl.first());
      }
    }
  };

  this.ajaxPavilion = function(parent, _event) {
    clearTimeout(timeoutAjaxPavilion);
    timeoutAjaxPavilion = setTimeout(function () {

      if(window.location.hash == '') {
        return;
      }

      // Устанавливаем выбранные элементы в панели фильтра
      it.setActiveElementsPanel(window.location.hash);

      let parentId = parent.attr("id")
          ? parent.attr("id")
          : parent.children()[0].attr("id"),
        arrElemId = parentId.split("-"),
        indexIdInArr = $.inArray("pavilion", arrElemId),
        idPavilion = arrElemId[indexIdInArr + 1],
        levelIdInArr = $.inArray("level", arrElemId),
        numberLevel = arrElemId[levelIdInArr + 1],
        lang = $("html").attr("lang");

      $.ajax({
        url: "/" + lang + "/api/index.php",
        data: {
          component: "get.pavilion",
          lang: lang,
          pavilion: idPavilion,
          level: numberLevel
        },
        dataType: "json",
        beforeSend: function() {},
        success: function(_data) {
          let tcomplex = $("[data-tcomplex]"),
            popup = tcomplex.find("[data-popup-tcomplex]"),
            titlePopup = tcomplex.find("[data-title-popup-tcomplex]"),
            contentPopup = tcomplex.find("[data-content-popup-tcomplex]"),
            mapTcomplex = tcomplex.find("[data-map-tcomplex]"),
            _matrix = mapTcomplex.css("transform").split(/[\s,\(\))]+/),
            selectorEl =
              '[id*="pavilion-' +
              idPavilion +
              '"][id*="level-' +
              numberLevel +
              '"]';

          // Очищаем активность у конгрессных помещений
          $("[data-conference-halls-tcomplex]").removeClass("active");

          // Очищаем выделенные павильоны на карте
          it.clearActivePavilion();

          // Выделяем активный элемент
          var activePavilion = $(
            '[id*="pavilion-' + idPavilion + '"][id*="level-' + numberLevel + '"]'
          );
          activePavilion.addClass("active");
          // Если у павильона нет залов, то подсвечиваем весь павильон
          if (!activePavilion.find('[id*="pav-"][id*="hall-"]').length) {
            $('[id*="pavilion-' + idPavilion + '"]')
              .find(
                '[id*="pav-' +
                  idPavilion +
                  '"][id*="-hover"]'
              )
              .addClass("open-popup");
          }

          titlePopup.html(_data.title);
          contentPopup.html(_data.content);

          // Открываем попап и позиционируем карту, если попап открыт - просто позиционируем карту
          if (tcomplex.hasClass("open-popup")) {
            it.setPositionMap(tcomplex, mapTcomplex, selectorEl);
          } else {
            // Запоминаем позицию и масштаб карты до открытия попапа
            currMaxrix =
              _matrix.length > 1 ? _matrix : ["", "1", "", "", "1", "0", "0", ""];
            // Открываем попап
            it.openPopup(popup, tcomplex, mapTcomplex, selectorEl);
          }

          tcomplex.addClass("show-active-pavilion");

          var sliders = contentPopup.find("[data-typical-slider]");
          if (sliders.length) {
            setTimeout(function() {
              sliders.each(function(index) {
                TypicalSlider.init($(this));
              });
            }, timeoutOpenPopup);
          }

          var tabs = contentPopup.find("[data-tabs]");
          if (tabs.length) {
            let paramsUrl = it.getObjFromHash(window.location.hash),
              numberHall;

            if (_event && _event.closest('[id*="pav-"][id*="hall-"]').length) {
              let $hall = _event.closest('[id*="pav-"][id*="hall-"]'),
                hallId = $hall.attr("id"),
                arrHallId = hallId.split("-"),
                indexHallInArr = $.inArray("hall", arrHallId);

              numberHall = arrHallId[indexHallInArr + 1];
            }
            if (paramsUrl["hall"]) {
              numberHall = paramsUrl["hall"];
            }

            Tabs.init(tabs);
            it.initTabsForHall(contentPopup, numberHall);
          }else{
            let paramsUrl = it.getObjFromHash(window.location.hash);
            if (paramsUrl["level"]) {
              numberLevel = paramsUrl["level"][0];
            }

            it.switchLevel(numberLevel);
          }

          var tablePopup = contentPopup.find("table");
          if (tablePopup.length) {
            tablePopup.each(function(index, value) {
              let $this = $(this);

              if (!$this.closest("table-scroll").length) {
                $this.wrap('<div class="table-scroll"></div>');
              }
            });

            var tableScroll = contentPopup.find(".table-scroll");
            if (tableScroll.length) {
              setTimeout(function() {
                TableScroll.init(tableScroll);
              }, timeoutOpenPopup);
            }
          }

          popup.find(".nano").nanoScroller();
        }
      });
    },350);
  };

  this.ajaxConferenceHalls = function(conferenceHalls) {
    clearTimeout(timeoutAjaxConferenceHalls);
    timeoutAjaxConferenceHalls = setTimeout(function () {

      let conferenceHallsId = conferenceHalls.data("conference-halls-tcomplex"),
        selectorEl =
          '[data-conference-halls-tcomplex="' + conferenceHallsId + '"]',
        lang = $("html").attr("lang"),
        messages = {
          square: "Площадь зала",
          height: "Высота потолков",
          number_seats: "Количество мест",
          maximum: "максимальное",
          persons: "чел.",
          lineSize: "м",
          squareSize: "кв. м",
          theatreSeating: "театр",
          classSeating: "класс",
          roundSeating: "круглый",
          standupMealSeating: "фуршет"
        };

      if (lang === "en") {
        messages = {
          square: "Hall square",
          height: "Ceiling height",
          number_seats: "Number of seats",
          maximum: "Maximum",
          persons: "persons",
          lineSize: "m.",
          squareSize: "sq.m.",
          theatreSeating: "theatre",
          classSeating: "the class",
          roundSeating: "round",
          standupMealSeating: "stand-up meal"
        };
      }

      $.ajax({
        url: "/" + lang + "/api/index.php",
        data: {
          component: "get.conference.hall",
          lang: lang,
          id: conferenceHallsId
        },
        dataType: "json",
        beforeSend: function() {},
        success: function(_data) {
          let tcomplex = $("[data-tcomplex]"),
            popup = tcomplex.find("[data-popup-tcomplex]"),
            titlePopup = tcomplex.find("[data-title-popup-tcomplex]"),
            contentPopup = tcomplex.find("[data-content-popup-tcomplex]"),
            mapTcomplex = tcomplex.find("[data-map-tcomplex]"),
            _matrix = mapTcomplex.css("transform").split(/[\s,\(\))]+/);

          titlePopup.empty();
          contentPopup.empty();

          var templateContentHtml =
            "{% if data.area|length or data.ceilingHeight|length or data.numberSeats|length %}" +
  	          '<div class="table-conference-halls">' +
  		          '<div class="item">' +
  			          '<div class="item__name">' +
  				          messages.square +
  				          ":" +
  			          "</div>" +
  			          '<div class="item__count">' +
  				          "{{ data.area }}" +
  				          '<span class="item__units">' +
  					          messages.squareSize +
  				          "</span>" +
  			          "</div>" +
  		          "</div>" +
  		          '<div class="item">' +
  			          '<div class="item__name">' +
  				          messages.height +
  				          ":" +
  			          "</div>" +
  			          '<div class="item__count">' +
  				          "{{ data.ceilingHeight }}" +
  				          '<span class="item__units">' +
  					          messages.lineSize +
  				          "</span>" +
  			          "</div>" +
  		          "</div>" +
  		          '<div class="item">' +
  			          '<div class="item__name">' +
  				          messages.number_seats +
  				          '<span class="item__note">(' +
  					          messages.maximum +
  				          "):</span>" +
  			          "</div>" +
  			          '<div class="item__count">' +
  				          "{{ data.numberSeats }}" +
  				          '<span class="item__units">' +
  					          messages.persons +
  				          "</span>" +
  			          "</div>" +
  		          "</div>" +
  	          "</div>" +
            "{% endif %}" +
            "{% if data.scheme|length %}" +
  	          '<div class="scheme-conference-halls">'+
                  '<div class="item {{(data.seatingGuests1|length ? \'active\')}}">'+
                      '<div class="item__title">' + messages.theatreSeating + '</div>'+
                      '<div class="item__count">{{ data.seatingGuests1 }}</div>'+
                  '</div>'+
                  '<div class="item {{(data.seatingGuests2|length ? \'active\')}}">'+
                      '<div class="item__title">' + messages.classSeating + '</div>'+
                      '<div class="item__count">{{ data.seatingGuests2 }}</div>'+
                  '</div>'+
                  '<div class="item {{(data.seatingGuests3|length ? \'active\')}}">'+
                      '<div class="item__title">' + messages.roundSeating + '</div>'+
                      '<div class="item__count">{{ data.seatingGuests3 }}</div>'+
                  '</div>'+
                  '<div class="item {{(data.seatingGuests4|length ? \'active\')}}">'+
                      '<div class="item__title">' + messages.standupMealSeating + '</div>'+
                      '<div class="item__count">{{ data.seatingGuests4 }}</div>'+
                  '</div>'+
              '</div>'+
            "{% endif %}" +
            "{% if data.descr|length %}" +
  	          '<div class="descr-conference-halls">{{ data.descr|raw }}</div>' +
            "{% endif %}" +
            "{% if data.slider|length %}" +
  	          '<div class="slider-conference-halls">{{ data.slider|raw }}</div>' +
            "{% endif %}";

          var templateAccordion = Twig.twig({
            data:
              '<div class="accordion__item" data-accordion-conference-halls="true" data-content-conference-hall-popup="true" data-id-pavilion="{{ data.pavilion_id }}" data-id-conference-hall-accordion="{{ data.id }}">' +
  	            '<div class="accordion__item-link" data-accordion-toogle-conference-halls="true">' +
  		            '<div class="accordion__item-title">{{ data.title|raw }}</div>' +
  		            '<div class="accordion__item-arrows btn-dropdown">' +
  			            '<span class="svg-icon ">' +
  				            "<svg>" +
  					            '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-dropdown"></use>' +
  				            "</svg>" +
  			            "</span>" +
  		            "</div>" +
  	            "</div>" +
  	            '<div class="accordion__item-content main-text" data-accordion-content-conference-halls="true">' +
  		            templateContentHtml +
  	            "</div>" +
              "</div>"
          });

          if (_data.items.length > 1) {

            titlePopup.html(_data.title);
            contentPopup.html(
              '<div class="accordion" data-wrap-accordion-conference-halls="true"></div>'
            );

            var accordionPopup = contentPopup.find(".accordion");

            _data.items.forEach(function(item, i) {
              var currAccoddion = accordionPopup.append(
                templateAccordion.render({
                  data: {
                    id: item.id,
                    pavilion_id: item.pavilion_id,
                    title: item.title,
                    area: item.area ? item.area : "",
                    ceilingHeight: item.ceiling_height ? item.ceiling_height : "",
                    numberSeats: item.number_seats ? item.number_seats : "",
                    scheme: item.scheme ? item.scheme : "",
                    descr: item.description ? item.description : "",
                    slider: item.slider_html ? item.slider_html : "",
                    seatingGuests1: item.seating_guests.type1,
                    seatingGuests2: item.seating_guests.type2,
                    seatingGuests3: item.seating_guests.type3,
                    seatingGuests4: item.seating_guests.type4
                  }
                })
              );

              // Устанавливаем в панели фильтра значения для первого элемента в списке конгресс залов
              if(i === 0) {
                it.setActiveElementsPanel(window.location.hash, item.pavilion_id, item.id, true);
              }
            });
          } else {
            var templateContent = Twig.twig({
                data: templateContentHtml
              }),
              item = _data.items[0];

            titlePopup.html(item.title);

            contentPopup.append('<div data-content-conference-hall-popup="true" data-id-pavilion="'+ item.pavilion_id +'" data-id-conference-hall-accordion="' + item.id + '">' +
              templateContent.render({
                data: {
                  area: item.area ? item.area : "",
                  ceilingHeight: item.ceiling_height ? item.ceiling_height : "",
                  numberSeats: item.number_seats ? item.number_seats : "",
                  scheme: item.scheme ? item.scheme : "",
                  descr: item.description ? item.description : "",
                  slider: item.slider_html ? item.slider_html : "",
                  seatingGuests1: item.seating_guests.type1,
                  seatingGuests2: item.seating_guests.type2,
                  seatingGuests3: item.seating_guests.type3,
                  seatingGuests4: item.seating_guests.type4
                }
              }) + '</div>'
            );

            // Устанавливаем выбранные элементы в панели фильтра
            it.setActiveElementsPanel(window.location.hash, item.pavilion_id, item.id, true);
          }

          // Очищаем выделенные павильоны на карте
          it.clearActivePavilion();
          tcomplex.removeClass("show-active-pavilion");

          $("[data-conference-halls-tcomplex]").removeClass("active");
          $(selectorEl).addClass("active");

          // Открываем попап и позиционируем карту, если попап открыт - просто позиционируем карту
          if (tcomplex.hasClass("open-popup")) {
            it.setPositionMap(tcomplex, mapTcomplex, selectorEl);
          } else {
            // Запоминаем позицию и масштаб карты до открытия попапа
            currMaxrix =
              _matrix.length > 1 ? _matrix : ["", "1", "", "", "1", "0", "0", ""];
            // Открываем попап
            it.openPopup(popup, tcomplex, mapTcomplex, selectorEl);
          }

          var sliders = contentPopup.find("[data-typical-slider]");
          if (sliders.length) {
            setTimeout(function() {
              sliders.each(function(index) {
                TypicalSlider.init($(this));
              });
            }, timeoutOpenPopup);
          }

          var tabs = contentPopup.find("[data-tabs]");
          if (tabs.length) {
            Tabs.init(tabs);
          }

          var tableScroll = contentPopup.find(".table-scroll");
          if (tableScroll.length) {
            setTimeout(function() {
              TableScroll.init(tableScroll);
            }, timeoutOpenPopup);
          }

          var currAccoddion = contentPopup.find("[data-id-conference-hall-accordion]"),
              paramsUrl = it.getObjFromHash(window.location.hash);

          if (currAccoddion.length) {
            if (paramsUrl["item_conference_halls"]) {
              var currAccordion = contentPopup.find(
                '[data-id-conference-hall-accordion="' +
                  paramsUrl["item_conference_halls"] +
                  '"]'
              );
              if (currAccordion.length) {
                var $accordionToogle = currAccordion
                    .closest("[data-wrap-accordion-conference-halls]")
                    .find("[data-accordion-toogle-conference-halls]"),
                  $accordion = $accordionToogle.closest("[data-accordion-conference-halls]"),
                  $accordionContent = $accordionToogle.next(
                    "[data-accordion-content-conference-halls]"
                  );

                $accordion.removeClass("open");
                $accordionContent.slideUp(400);

                currAccordion
                  .find("[data-accordion-content-conference-halls]")
                  .slideDown(400, function() {
                    currAccordion.addClass("open");
                  });

                var currPavilion = $('[data-content-conference-hall-popup][data-id-conference-hall-accordion="' + paramsUrl["item_conference_halls"] + '"]').data('id-pavilion');
                // Устанавливаем выбранные элементы в панели фильтра
                it.setActiveElementsPanel(window.location.hash, currPavilion, paramsUrl["item_conference_halls"], true);
              }
            }
          }

          if (paramsUrl["level"]) {
            it.switchLevel(paramsUrl["level"][0]);
          }

          popup.find(".nano").nanoScroller();
        }
      });
    },350);
  };

  this.ajaxAdvertisingConstructions = function(parent, _event) {
    clearTimeout(timeoutAjaxAdvertisingConstructions);
    timeoutAjaxAdvertisingConstructions = setTimeout(function () {

      let idAdvertising = parent.data('advertising-constructions-tcomplex'),
        lang = $('html').attr('lang');


      $.ajax({
        url: '/' + lang + '/api/index.php',
        data: {
          component: 'get.ad.construction',
          ad: idAdvertising
        },
        dataType: 'json',
        beforeSend: function(){},
        success: function(_data){
          let tcomplex = $('[data-tcomplex]'),
            popup = tcomplex.find('[data-popup-tcomplex]'),
            titlePopup = tcomplex.find('[data-title-popup-tcomplex]'),
            contentPopup = tcomplex.find('[data-content-popup-tcomplex]'),
            mapTcomplex = tcomplex.find('[data-map-tcomplex]'),
            _matrix = mapTcomplex.css('transform').split(/[\s,\(\))]+/),
            selectorEl = '[data-id-size-adv-constructions="' + idAdvertising + '"]';

          // Очищаем активность у конгрессных помещений
          $('[data-conference-halls-tcomplex]').removeClass('active');
          // Очищаем выделенные павильоны на карте
          it.clearActivePavilion();
          tcomplex.removeClass('show-active-pavilion');


          titlePopup.html(_data.title + ' ' + _data.code);
          contentPopup.html(_data.content);

          // Открываем попап и позиционируем карту, если попап открыт - просто позиционируем карту
          if(tcomplex.hasClass('open-popup')) {
            it.setPositionMap(tcomplex, mapTcomplex, selectorEl);

          }else{
            // Запоминаем позицию и масштаб карты до открытия попапа
            currMaxrix = (_matrix.length > 1) ? _matrix : ['','1','','','1','0','0',''];
            // Открываем попап
            it.openPopup(popup, tcomplex, mapTcomplex, selectorEl);
          }

          var sliders = contentPopup.find('[data-typical-slider]');
          if(sliders.length) {
            setTimeout(function(){
              sliders.each(function(index) {
                TypicalSlider.init($(this));
              });
            }, timeoutOpenPopup);
          }

          let paramsUrl = it.getObjFromHash(window.location.hash),
              currLevel = $('[data-item-level-tcomplex].active').first().data('item-level-tcomplex');

          if (paramsUrl["level"] && (currLevel != paramsUrl["level"][0])) {
            it.switchLevel(paramsUrl["level"][0]);
          }

          popup.find('.nano').nanoScroller();
        }
      });
    },350);
  };

  this.openPopup = function(popup, tcomplex, mapTcomplex, selectorEl) {
    let innerMap = $("[data-map-inner-tcomplex]"),
      heightInnerMap = innerMap.height(),
      heightHeader = $("[data-header]").outerHeight(),
      heightFilterPanel = $('[data-filter-panel-tcomplex]').outerHeight(),
      $topBanner = $("[data-top-head-banner]"),
      heightTopBanner = $topBanner.length ? $topBanner.outerHeight() : 0,
      heightMapWithOpenPopup =
        $(window).outerHeight() / 2 - (heightHeader + heightTopBanner + heightFilterPanel) / 2,
      it = this;

    // Фиксируем для карты высоту, на момент открытия попапа, чтобы высота у нас не дёргалась
    innerMap.height(heightInnerMap);
    tcomplex.addClass("animate");

    popup.show(0, function() {
      popup.stop().animate(
        {
          "margin-top": heightMapWithOpenPopup,
          "margin-left": 0,
          opacity: 1
        },
        timeoutOpenPopup,
        "linear",
        function() {
          tcomplex.addClass("open-popup");
          innerMap.height(heightMapWithOpenPopup);
          $("[data-filter-tcomplex]").hide();
          popup.find(".nano").nanoScroller();

          it.setPositionMap(tcomplex, mapTcomplex, selectorEl);
        }
      );
    });
  };

  this.clickOnMap = function(event) {
    let curr = $(event.target),
      parentPavilion = curr.closest('[id*="pav-"]'),
      conferenceHalls = curr.closest("[data-conference-halls-tcomplex]"),
      advertisingConstructions = curr.closest('[data-advertising-constructions-tcomplex]'),
      containerExhibitionDetail = curr.closest(
        "[data-wrap-map-exhibition-detail-tcomplex]"
      );

    // clickSvg - объявлена в файле /local/templates/expocentr/js/libs/jquery.panzoom_custom.js
    // для понимания сработал клик или перетаскивание
    if (clickSvg) {
      if (parentPavilion.length && !containerExhibitionDetail.length) {
        if (parentPavilion.closest('[id*="pavilion-"][id*="-level-"]').length) {
          let pavArr = parentPavilion.attr("id").split("-");
          let pavData = {};
          for (var i = 0; i < pavArr.length; i += 2) {
            if (pavArr[i] !== "level") {
              if (pavArr[i] === "pav") {
                pavData["pavilion"] = pavArr[i + 1];
              } else if (pavArr[i] === "hall") {
                pavData[pavArr[i]] = pavArr[i + 1];
              }
            }
          }
          this.setHash(this.getHashFromObj(pavData));
        }
      }

      if (conferenceHalls.length && !containerExhibitionDetail.length) {
        let confHallId = conferenceHalls.attr("id"),
            arrElemId = conferenceHalls.data('id').split("-"),
            indexIdInArr = $.inArray("level", arrElemId),
            numberLevel = arrElemId[indexIdInArr + 1];

        let urlObj = {
          category: "conference_halls",
          conference_hall: confHallId,
          level: numberLevel
        };
        this.setHash(this.getHashFromObj(urlObj));
        // this.ajaxConferenceHalls(conferenceHalls);
      }

      if (advertisingConstructions.length && !containerExhibitionDetail.length) {
        let construct = advertisingConstructions.data('advertising-constructions-tcomplex'),
            arrElemId = advertisingConstructions.attr('id').split("-"),
            indexIdInArr = $.inArray("level", arrElemId),
            numberLevel = arrElemId[indexIdInArr + 1];

        let urlObj = {
          category: 'advertising_constructions',
          subcategory: advertisingConstructions.data('type-advertising-constructions-tcomplex'),
          adv_construction: construct,
          level: numberLevel
        }
        
        this.setHash(this.getHashFromObj(urlObj));
        // it.ajaxAdvertisingConstructions(advertisingConstructions, curr);
      }
    }
  };

  this.clickEvents = function() {
    let tcomplex = $("[data-tcomplex]"),
      contentTerritory = tcomplex.find("[data-map-wrap-tcomplex]"),
      mapTerritory = tcomplex.find("[data-map-tcomplex]"),
      filter = $("[data-filter-tcomplex]"),
      it = this;

    // Обрабатываем клик по карте
    mapTerritory.on("click touchstart", function (e) {
      // Если touchDevice = true, то не обрабатываем событие клика,
      // потому что отработает событие touchstart
      if (e.type == "click") {
        if (!touchDevice) {
          it.clickOnMap(e);
        }
        touchDevice = false;
      }

      // Если происходит событие touch, то открываем попап спустя временной интервал,
      // чтобы в плагине panzoom успела отработать функция move
      if (e.type == "touchstart") {
        touchDevice = true;

        setTimeout(function() {
          it.clickOnMap(e);
        }, 100);

        // Для touch событий (а это мобилка), показываем/скрываем тултип на карте по клику
        var currIcon = $(event.target).closest("[data-icon-tooltip-tcomplex]");
        if (currIcon.length) {
          e.stopPropagation();
        } else {
          $("[data-tooltip-tcomplex]").removeClass("active");
        }
      }
    });

    // Отображаем/скрываем подсказки по ховеру
    let iconTooltipTcomplex = $('[data-icon-tooltip-tcomplex]');
    if(iconTooltipTcomplex.length) {

        iconTooltipTcomplex.hover(
            function(e){
                e.preventDefault();
                it.showTooltip($(this));
            },
            function(e){
                e.preventDefault();
                $('[data-tooltip-tcomplex]').removeClass('active');
            }
        );
    }

    // Обработка кнопки открытия фильтра в попапе
    $("[data-tcomplex]").on(
      "click",
      "[data-open-filter-popup-tcomplex]",
      function(e) {
        e.preventDefault();
        e.stopPropagation();

        $("[data-wrap-filter-popup-tcomplex]").toggleClass("open");
        $("[data-filter-popup-tcomplex]").slideToggle();
      }
    );

    // Переключение уровней
    $(document).on("click", "[data-item-level-tcomplex]", function() {
      it.switchLevel($(this).data("item-level-tcomplex"));
    });

    // Закрытие попапа
    $("[data-close-popup-tcomplex]").on("click", function() {
      window.location.hash = "";
    });

    // Приближение карты
    $("[data-zoom-in-tcomplex]").on("click", function() {
      mapTerritory.panzoom("enable");
      mapTerritory.panzoom("zoom", false, {
        offsetVisibleAreaDescktop: true
      });
    });

    // Отдаление карты
    $("[data-zoom-out-tcomplex]").on("click", function() {
      mapTerritory.panzoom("enable");
      mapTerritory.panzoom("zoom", true, {
        offsetVisibleAreaDescktop: true
      });
    });

    // Открытие/закрытие фильтра
    $("[data-toggle-filter-tcomplex]").on("click", function(e) {
      e.stopPropagation();
      filter.toggleClass("open");
    });

    // Открытие фильтра
    $("[data-open-filter-tcomplex]").on("click", function(e) {
      if(!$(this).hasClass('open')) {
        e.stopPropagation();
        filter.addClass("open");

        if (Media.detect().isMobile && !filter.hasClass("load"))
          filter.addClass("load");
      }
    });

    // клики по категоряим
    $("[data-title-category-tcomplex]").on("click", function() {
      let categoryVal = $(this)
        .closest("[data-item-category-tcomplex]")
        .data("item-category-tcomplex");
      let subcategories =
        $(this)
          .closest("[data-item-category-tcomplex]")
          .find("[data-type-subcategory-tcomplex]").length > 0
          ? $(this)
              .closest("[data-item-category-tcomplex]")
              .find("[data-type-subcategory-tcomplex]")
          : false;
      let hashObj = {
        category: categoryVal
      };

      if (
        subcategories &&
        !$(this)
          .closest("[data-title-category-tcomplex]")
          .hasClass("active")
      ) {
        let firstSub = subcategories[0];
        let firstSubVal = $(firstSub).data("type-subcategory-tcomplex");

        hashObj.subcategory = [firstSubVal];

        it.setHash(it.getHashFromObj(hashObj));
      } else {
        it.setHash(it.getHashFromObj(hashObj));
      }
    });

    $("[data-conference-halls-tcomplex]").on("click", function() {
      let _this = $(this);
      let _id = _this.attr("id");

      let hashObj = it.getObjFromHash(window.location.hash);

      hashObj.conference_hall = _id;

      it.setHash(it.getHashFromObj(hashObj));
    });

    // клики по субкатегориям
    $("[data-type-subcategory-tcomplex]").on("click", function() {
      let _this = $(this),
        mapTcomplex = $("[data-map-tcomplex]"),
        currSubcategory = _this.closest("[data-item-subcategory-tcomplex]");

      let filterCat = _this
          .closest(".item-category-tcomplex")
          .data("item-category-tcomplex"),
        filterSubCat = _this
          .closest("[data-type-subcategory-tcomplex]")
          .data("type-subcategory-tcomplex");

      if (currSubcategory.hasClass("multi")) {
        if (_this.is('.active') && _this.closest('.subcategory').find('.active').length === 1) {
          window.location.hash = ''
        } else {
          let currHashObj = it.getObjFromHash(window.location.hash);

          if (currHashObj.subcategory) {
            if (currHashObj.subcategory.indexOf(filterSubCat) === -1) {
              currHashObj.subcategory.push(filterSubCat);
              _this
                .closest("[data-type-subcategory-tcomplex]")
                .addClass("active");
            } else {
              currHashObj.subcategory = currHashObj.subcategory.filter(
                function (sub) {
                  return sub !== filterSubCat
                }
              );
              if (!currHashObj.subcategory[0]) {
                delete currHashObj.subcategory;
              }
              if (currHashObj.adv_construction) {
                delete currHashObj.adv_construction
              }
              _this
                .closest("[data-type-subcategory-tcomplex]")
                .removeClass("active");
            }
          } else if (!currHashObj.subcategory) {
            currHashObj = {
              category: filterCat,
              subcategory: filterSubCat
            }
          } else {
            currHashObj.subcategory = [filterSubCat];
          }
          $('[data-icon-tooltip-tcomplex="pedestrian_entrances"]').show()
          it.setHash(it.getHashFromObj(currHashObj));
        }

      } else {
        let hash = {
          category: filterCat,
          subcategory: filterSubCat
        };

        it.setHash(it.getHashFromObj(hash));
      }
    });

    // accordion conference halls panel
    $('.main').on('click', '[data-accordion-toogle-conference-halls]', function (event, state) {

        var $accordionToogle = $(this),
            $accordion = $accordionToogle.closest('[data-accordion-conference-halls]'),
            $accordionContent = $accordionToogle.next('[data-accordion-content-conference-halls]');

            if ($accordion.hasClass('open')) {
                $accordion.removeClass('open');
                $accordionContent.stop().slideUp(400);

                it.clearPavilionAndHallPanel();
            } else {
              $('[data-accordion-conference-halls]').removeClass('open');
              $('[data-accordion-content-conference-halls]').stop().slideUp(400);

                $accordionContent.stop().slideDown(400, function () {
                    $accordion.addClass('open');

                    var sliderInnerAccordion = $accordionContent.find('[data-typical-slider]');
                    if(sliderInnerAccordion.length && sliderInnerAccordion.hasClass('slick-initialized')) {
                        sliderInnerAccordion.slick('refresh');
                    }

                    // Устанавливаем выбранные элементы в панели фильтра
                    it.setActiveElementsPanel(window.location.hash, $accordion.data('id-pavilion'), $accordion.data('id-conference-hall-accordion'), true);
                });
            }

            var tabsWrapAccordion = $accordionContent.closest('[data-tabs]');
            if(tabsWrapAccordion.length && Media.detect().isMobile) {
                setTimeout(function(){
                    Tabs.updateTabs(tabsWrapAccordion);
                }, 400);
            }

            var table = $accordionContent.find('[data-scroll-index]');
            if(table.length && !$accordion.hasClass('open')) {
                TableScroll.updateContent(table.data('scroll-index'));
            }
    });
  };

  this.hoverEvents = function() {
    // Ховер на павильоне
    if (Media.detect().isDesktop) {
      $('[id*="pav-"]').hover(
        function() {
          let currId = $(this).attr("id"),
            arrElemId = currId.split("-"),
            indexIdInArr = $.inArray("pav", arrElemId),
            numberPavilion = arrElemId[indexIdInArr + 1];

          $('[id*="pav-' + numberPavilion + '"][id*="-hover"]').css(
            "opacity",
            "1"
          );

          var indexIdHallInArr = $.inArray("hall", arrElemId);
          if (indexIdHallInArr >= 0) {
            $('[id*="pav-"][id*="level-"][id*="hall-"]').removeClass(
              "hover-hall"
            );
            $(this).addClass("hover-hall");
          }
        },
        function() {
          $('[id*="pav-"][id*="-hover"]').removeAttr("style");
          $('[id*="pav-"][id*="level-"][id*="hall-"]').removeClass(
            "hover-hall"
          );
        }
      );
    }
  };

  this.setActiveCategoryFilter = function(_this, isSetFirstSubcategory) {
    let tcomplex = $("[data-tcomplex]"),
      mapTcomplex = tcomplex.find("[data-map-tcomplex]"),
      nanoScroll = tcomplex.find(".nano"),
      currCategory = _this.closest("[data-item-category-tcomplex]"),
      valCurrCategory = currCategory.data("item-category-tcomplex"),
      currSubcategory = currCategory.find("[data-item-subcategory-tcomplex]"),
      oldCategory = tcomplex.find("[data-item-category-tcomplex].active"),
      valOldCategory = oldCategory.data("item-category-tcomplex"),
      listActiveSubcategory = $("[data-item-subcategory-tcomplex].active"),
      filter = tcomplex.find("[data-filter-tcomplex]"),
      categories = filter.find("[data-category-list-filter-tcomplex]"),
      categoriesInner = filter.find(
        "[data-category-list-inner-filter-tcomplex]"
      );

    if (!currCategory.hasClass("active")) {
      // При переключении категории присваиваем активность текущему элементу
      oldCategory.removeClass("active");
      $('[data-item-category-tcomplex="' + valCurrCategory + '"]').addClass(
        "active"
      );

      // При переключении категории отображаем стрелки входов
      mapTcomplex.removeClass("hidden-pedestrian-entrance");

      // Для карты удаляем все классы категорий и добавляем класс активной категории
      mapTcomplex
        .removeClass("category-" + valOldCategory)
        .addClass("category-" + valCurrCategory);

      // При переключении категории удаляем все классы подкатегорий для карты
      // и убираем активность у этих подкатегорий
      if (listActiveSubcategory.length > 0) {
        let mapActiveSubcategory = mapTcomplex.find(
          '[id*="filter_category"][id*="' + valOldCategory + '"].active'
        );

        listActiveSubcategory.removeClass("active");
        if (mapActiveSubcategory) {
          mapActiveSubcategory.removeClass("active");
        }
      }

      if (currSubcategory.length > 0) {
        // При открытиии категории у которой есть подкатегории
        // добавляем активность первой подкатегории
        // if(!isSetFirstSubcategory) {
        var firstSubcategory = currSubcategory
          .first()
          .find("[data-title-subcategory-tcomplex]");

        it.setActiveSubcategoryFilter(firstSubcategory);
        // }
      }

      // При переключении пересчитываем наноскроллер
      nanoScroll.nanoScroller().addClass("start");
      // TerritoryComplex.settingsScrollCategories(tcomplex);
    }
  };

  // включение субкатегории
  this.showSubcategory = function(cat, sub) {
    let mapTcomplex = $("[data-map-tcomplex]"),
      currSubCategory = $('[data-type-subcategory-tcomplex="' + sub + '"]'),
      currIsActive = currSubCategory.hasClass("active"),
      valCurrSubCategory = currSubCategory.data("item-subcategory-tcomplex");

    if (currSubCategory.hasClass("multi")) {
      let c = $(cat).data("item-category-tcomplex");
      let subTranlit = {
        ladders_elevators: ['lesniza', 'eskalator', 'passazirskiy_lift', 'gruzovoi_lift'],
        assembly_gate: 'arr_green'
      }

      if (sub === 'ladders_elevators') {
        subTranlit['ladders_elevators'].forEach(function (el) {
          let currSub = mapTcomplex.find(
            '[id*="filter_category-' + c + '"][id*="' + el + '"]'
          );

          currSub.addClass("active");
        })
      } else if (sub === 'assembly_gate') {
        let currSub = mapTcomplex.find(
          '[id*="filter_category-' + c + '"][id*="' + (subTranlit[sub] ? subTranlit[sub] : sub) + '"]'
        );

        currSub.addClass("active");
        $('[data-icon-tooltip-tcomplex="pedestrian_entrances"]').hide()
      } else {
        let currSub = mapTcomplex.find(
          '[id*="filter_category-' + c + '"][id*="' + (subTranlit[sub] ? subTranlit[sub] : sub) + '"]'
        );

        currSub.addClass("active");
        $('[data-icon-tooltip-tcomplex="pedestrian_entrances"]').show()
      }

    } else {
      let fBtn = cat.querySelector(
        '[data-type-subcategory-tcomplex="' + sub + '"] .item__title'
      );

      this.setActiveSubcategoryFilter($(fBtn));
    }
  };

  this.setActiveSubcategoryFilter = function(_this, opts) {
    let mapTcomplex = $("[data-map-tcomplex]"),
      currSubCategory = _this.closest("[data-item-subcategory-tcomplex]"),
      currIsActive = currSubCategory.hasClass("active"),
      valCurrSubCategory = currSubCategory.data("item-subcategory-tcomplex");

    if (currSubCategory.hasClass("multi")) {
      let hashObj = it.getObjFromHash(window.location.hash);
      // Для подкатегорий с множественным выбором (чекбоксы)
      if (currIsActive) {
        // Если текущая подкатегория уже выбрана, снимаем у неё активность и выключаем на карте
        // элементы этой подкатегории
        currSubCategory.removeClass("active");
        $.each(valCurrSubCategory, function(i, item) {
          var mapActiveSubcategory = mapTcomplex.find(
            '[id*="filter_category"][id*="' + item + '"].active'
          );

          if (mapActiveSubcategory.length) {
            mapActiveSubcategory.removeClass("active");
          }
        });
      } else {
        // Если текущая подкатегория не была выбрана, включаем у неё активность и подсвечиваем на карте
        // элементы этой подкатегории
        currSubCategory.addClass("active");
        $.each(valCurrSubCategory, function(i, item) {
          var mapSubcategory = mapTcomplex.find(
            '[id*="filter_category"][id*="' + item + '"]'
          );

          if (mapSubcategory.length) {
            mapSubcategory.addClass("active");
          }
        });
      }
    } else {
      // Для подкатегорий с одиночным выбором (радиобаттоны)
      var currCategory = currSubCategory.closest(
          "[data-item-category-tcomplex]"
        ),
        nameCategory = currCategory.data("item-category-tcomplex"),
        allSubcategory = currCategory.find("[data-item-subcategory-tcomplex]");

      // Убираем активность у всех подкатегорий текущей категории
      allSubcategory.removeClass("active");
      // и выключаем на карте все иконки текущей категории
      mapTcomplex
        .find('[id*="filter_category"][id*="' + nameCategory + '"]')
        .removeClass("active");

      // Для выбранной подкатегории перебираем все типы иконок
      $.each(valCurrSubCategory, function(i, item) {
        // Если выбран тип "Все", тогда на карте включаем все иконки в текущей категории
        // и выходим из цикла
        if (item == "all") {
          currSubCategory.addClass("active");
          mapTcomplex
            .find('[id*="filter_category"][id*="' + nameCategory + '"]')
            .addClass("active");
          return false;
        }

        // Текущий тип иконки подсвечиваем на карте
        var mapSubcategory = mapTcomplex.find(
          '[id*="filter_category"][id*="' + item + '"]'
        );
        currSubCategory.addClass("active");
        if (mapSubcategory.length) {
          mapSubcategory.addClass("active");
        }
      });

      // Смена уровня для категорий которые есть только на одном из уровней
      var currLevel = currSubCategory.data("level-subcategory");
      if (!!currLevel) {
        let tcomplex = $("[data-tcomplex]"),
          currNameEl = currSubCategory.data("item-subcategory-tcomplex")[0],
          selectorEl = '[data-icon-tooltip-tcomplex="' + currNameEl + '"]';

        it.switchLevel(currLevel);

        // Центрируем карту на выбранную иконку
        if ($(selectorEl).length == 1) {
          it.setPositionMap(tcomplex, mapTcomplex, selectorEl, 3);
        } else {
          mapTcomplex.panzoom("setMatrix", [1, 0, 0, 1, 0, 0], {
            offsetVisibleAreaDescktop: true
          });
        }
      } else {
        mapTcomplex.panzoom("setMatrix", [1, 0, 0, 1, 0, 0], {
          offsetVisibleAreaDescktop: true
        });
      }
    }

    if (currSubCategory.data("type-subcategory-tcomplex") == "assembly_gate") {
      if (currSubCategory.hasClass("active")) {
        mapTcomplex.addClass("hidden-pedestrian-entrance");
      } else {
        mapTcomplex.removeClass("hidden-pedestrian-entrance");
      }
    }
  };

  // утилита для получения хэша из урла
  this.getHashFromURL = function(url) {
    if (url) {
      let h = url.split("#").slice(1);

      if (h.length > 0) {
        let res = h.reduce(function (acc, item) {
          return acc + '#' + item;
        }, "");

        return res;
      } else {
        return false;
      }
    } else {
      return false
    }
  };

  // утилита для получения объекта из хэша
  this.getObjFromHash = function(hash) {
    if (hash.length && hash.length > 1) {
      let hashArr = hash.split("#").slice(1);
      let res = {};

      hashArr.forEach(function (item) {
        let itemArr = item.split("=");

        if (itemArr[1].split(",").length > 0) {
          res[itemArr[0]] = itemArr[1].split(",");
        } else {
          res[itemArr[0]] = itemArr[1];
        }
      });

      return res;
    } else {
      // если передан пустой хэш, то возвращаем false
      return false;
    }
  };

  // утилита для получения хэша из объекта
  this.getHashFromObj = function(obj) {
    let hash = Object.keys(obj).reduce(function(acc, key) {
      let item = obj[key];
      let val;

      if (typeof item === "object" && item.length) {
        val = item.reduce(function (acc, it, i) {
          if (i === item.length - 1) {
            return acc + it;
          }

          return acc + it + ',';
        }, "");
      } else {
        val = item;
      }

      return acc + '#' + key + '=' + val;
    }, "");

    return hash;
  };

  // выставляем хэш
  this.setHash = function(hash) {
    window.location.hash = hash;
  };

  this.setPositionMap = function(tcomplex, mapTcomplex, selectorEl, _scale) {
    // Позиционирование карты
    let mapWrapTcomplex = tcomplex.find("[data-map-wrap-tcomplex]"),
      mapInnerTcomplex = tcomplex.find("[data-map-inner-tcomplex]"),
      currMatrix = mapTcomplex.css("transform").split(/[\s,\(\))]+/),
      currScale = !!currMatrix[1] ? currMatrix[1] : 1,
      collapsedFooterHeight = 26, // высота подвала в сдвинутом виде
      padsInsideVisArea = 30 * 2; // минимальный отступ от краев видимой зоны сверху и снизу

    // Получаем размер элемента в старом масштабе
    var oldSizeEl = document.querySelector(selectorEl).getBoundingClientRect(),
      // Определяем коэффициент Х - целая часть отношения ширины видимой области к ширине элемента (в масштабе 1)
      kX = parseInt(
        (mapTcomplex.width() - padsInsideVisArea) /
          (oldSizeEl.width / currScale)
      ),
      // Определяем коэффициент У - целая часть отношения высоты видимой области к высоте элемента (в масштабе 1)
      kY = parseInt(
        (mapTcomplex.height() - collapsedFooterHeight - padsInsideVisArea) /
          (oldSizeEl.height / currScale)
      ),
      // Для того, чтобы элемент полностью поместился в видимой области,
      // берём минимальное значение из коэффициентов
      kResult = Math.min(kX, kY),
      scale,
      maxScale = Media.detect().isMobile ? 4 : 2;

    if (kResult >= 8) {
      scale = 8;
    } else {
      scale = kResult <= 1 ? 1 : kResult;
    }

    scale = _scale ? _scale : Math.min(maxScale, scale);

    // Устанавливаем карту в нужный масштаб без сдвига,
    // чтобы корректно посчитать позицию и размеры текущего павильона
    mapTcomplex.panzoom("setMatrix", [scale, 0, 0, scale, 0, 0], {
      offsetVisibleAreaDescktop: true
    });

    // Получаем размер элемента в новом масштабе
    var newSizeEl = document.querySelector(selectorEl).getBoundingClientRect(),
      // Определяем величину смещения карты по оси Х.
      // left0 - выравнивает элемент по левому краю видимой области
      left0 = newSizeEl.left - mapInnerTcomplex.offset().left,
      // А дальше сдвигаем на величину равную ширине видимой области минус ширина элемента и всё это пополам
      deltaX = (mapTcomplex.width() - newSizeEl.width) / 2 - left0,
      // Определяем величину смещения карты по оси Y.
      // top0 выравнивает элемент по верхнему краю видимой области
      top0 =
        newSizeEl.top + $(window).scrollTop() - mapWrapTcomplex.offset().top,
      // А дальше сдвигаем на величину равную высоте видимой области минус высота элемента и всё это пополам
      deltaY =
        (mapTcomplex.height() - newSizeEl.height - collapsedFooterHeight) / 2 -
        top0;

    // Сдвигаем карту
    mapTcomplex.panzoom("setMatrix", [scale, 0, 0, scale, deltaX, deltaY], {
      offsetVisibleAreaDescktop: true
      //animate: true
    });

    if ($("[data-wrap-map-exhibition-detail-tcomplex]").length) {
      tcomplex.addClass("show");
    }
  };

  this.switchLevel = function(numberLevel) {
    let mapTcomplex = $("[data-map-tcomplex]"),
      currBtnLevel = $('[data-item-level-tcomplex="' + numberLevel + '"]'),
      activeLevelOld = $("[data-item-level-tcomplex].active"),
      valActiveLevelOld = activeLevelOld.data("item-level-tcomplex");

    if (!currBtnLevel.length) {
      currBtnLevel = $('[data-item-level-tcomplex="2"]');
    }

    activeLevelOld.removeClass("active");
    currBtnLevel.addClass("active");

    mapTcomplex
      .removeClass("level-" + valActiveLevelOld)
      .addClass("level-" + numberLevel);
  };

  this.initTabsForHall = function(contentPopup, _numberHall) {
    let tabs = contentPopup.find("[data-tabs]");

    tabs.each(function(i, elem) {
      let tab = $(this);
      // Если у текущего таба есть дата атрибут data-hall-detail-tcomplex, то обрабатываем
      // этот таб особым образом
      if (tab.find("[data-hall-detail-tcomplex]").length) {
        let paramsUrl = it.getObjFromHash(window.location.hash);

        // Если в гет-параметр передаётся значение выбранного зала,
        // то мы переключаем вкладку на этот зал
        if (paramsUrl["hall"] ) {
          let activeNavTab = tab.find('[data-hall-detail-tcomplex="' + paramsUrl["hall"][0] + '"]');

          tab.find("[data-item-nav-tabs]").removeClass("active");
          tab.find("[data-pane-tabs]").removeClass("active");

          activeNavTab.addClass("active");
          tab.find('[data-pane-tabs="' + activeNavTab.data("item-nav-tabs") + '"]').addClass("active");
          it.setActiveHall(paramsUrl["hall"][0], activeNavTab.data("pavillion-detail-tcomplex"), activeNavTab.data("level-detail-tcomplex"));

          if(Media.detect().isMobile) {
            var indexActiveEl = tab.find("[data-item-nav-tabs]").index(activeNavTab);
            tab.find(".tabs__content").slick('slickGoTo', indexActiveEl);
          }
        } else {
          var activeTab;

          if (_numberHall) {
            // Если при клике на павильон указан номер конкретного зала, то открываем этот таб
            tab.find("[data-item-nav-tabs]").removeClass("active");
            tab.find("[data-pane-tabs]").removeClass("active");

            activeTab = tab.find(
              '[data-hall-detail-tcomplex="' + _numberHall + '"]'
            );
            activeTab.addClass("active");
            tab
              .find(
                '[data-pane-tabs="' + activeTab.data("item-nav-tabs") + '"]'
              )
              .addClass("active");
          } else {
            activeTab = tab.find("[data-item-nav-tabs].active");
          }

          if (activeTab.length) {
            var currHall = activeTab.data("hall-detail-tcomplex"),
              currPav = activeTab.data("pavillion-detail-tcomplex"),
              currLevel = activeTab.data("level-detail-tcomplex");

            if (paramsUrl["level"]) {
              // Если в гет параметр передаётся зал,
              // то переключаем вкладку и подсвечиваем первый в списке зал
              var elemHall = $(
                  '[id*="pav-' +
                    currPav +
                    '"][id*="level-' +
                    paramsUrl["level"] +
                    '"][id*="hall-"]'
                ).first(),
                arrHallId = elemHall.attr("id").split("-"),
                indexIdInArr = $.inArray("hall", arrHallId),
                numberHall = arrHallId[indexIdInArr + 1],
                activeNavTab = tab.find(
                  '[data-hall-detail-tcomplex="' + numberHall + '"]'
                );

              tab.find("[data-item-nav-tabs]").removeClass("active");
              tab.find("[data-pane-tabs]").removeClass("active");

              activeNavTab.addClass("active");
              tab
                .find(
                  '[data-pane-tabs="' +
                    activeNavTab.data("item-nav-tabs") +
                    '"]'
                )
                .addClass("active");

              it.setActiveHall(numberHall, currPav, paramsUrl["level"]);
            } else {
              // Если в гет параметр не передаётся зал,
              // то подсвечиваем зал для активной вкладки таба
              it.setActiveHall(currHall, currPav, currLevel);
            }
          }
        }

        // При переключении табов с залами по клику подсвечиваем текущий зал,
        // при условии что это не мобилка
        tab.find("[data-item-nav-tabs]").on("click", function() {
          if(!Media.detect().isMobile) {
            var currTab = $(this),
              currHall = currTab.data("hall-detail-tcomplex"),
              currPav = currTab.data("pavillion-detail-tcomplex"),
              currLevel = currTab.data("level-detail-tcomplex");

            it.setHash(
              it.getHashFromObj({
                pavilion: currPav,
                hall: currHall
              })
            );
          }
        });

        // Для мобильной версии табы переключаются с использованием слайдера, поэтому для них
        // клик не обрабатываем, а обрабатываем событие beforeChange
        tab
         .find(".tabs__content")
         .on("beforeChange", function(event, slick, currentSlide, nextSlide) {
            var currTab = tab.find("[data-item-nav-tabs]").eq(nextSlide),
              currHall = currTab.data("hall-detail-tcomplex"),
              currPav = currTab.data("pavillion-detail-tcomplex"),
              currLevel = currTab.data("level-detail-tcomplex");

            isUpdateHash = false;
            it.setActiveElementsPanel('#pavilion='+ currPav +'#hall=' + currHall);
            it.setActiveHall(currHall, currPav, currLevel);
          });

        // Для мобильной версии при инициализации слайдера задаём устанавливаем текущий зал
        $(window).on('mdbreakpoint', function(e, breakpointOld, breakpointOldNew) {
          if((breakpointOld == 'isTablet' || breakpointOld == 'isDesktop' || breakpointOld == 'isDesktopHD') && (breakpointOldNew == 'isMobile')) {
            var indexActiveEl = tab.find("[data-item-nav-tabs].active").index();
            tab.find(".tabs__content").slick('slickGoTo', indexActiveEl);
          }
        });
      }
    });
  };

  this.setActiveHall = function(hall, pav, level) {
    let tcomplex = $("[data-tcomplex]"),
      mapTcomplex = tcomplex.find("[data-map-tcomplex]"),
      selectorEl = '[id*="pavilion-' + pav + '"][id*="level-' + level + '"]',
      el = $(
        '[id*="pav-' +
          pav +
          '"][id*="level-' +
          level +
          '"][id*="hall-' +
          hall +
          '"]'
      ),
      numberActiveLevel = $("[data-item-level-tcomplex].active").data(
        "item-level-tcomplex"
      );

    $('[id*="pav-"][id*="level-"][id*="hall-"]').removeClass("active");

    if (el.length) {
      // Переключаем уровень
      this.switchLevel(level);

      if (numberActiveLevel != level) {
        // И позиционируем карту на текущий павильон
        this.setPositionMap(tcomplex, mapTcomplex, selectorEl);
      }

      // Выставляем активность павильона на нужном уровне
      $('[id*="pavilion-"][id*="level-"]').removeClass("active");
      $(selectorEl).addClass("active");
      // Подсвечиваем текущий зал
      el.addClass("active");
    }
  };

  this.closePopup = function(tcomplex) {
    let popup = tcomplex.find("[data-popup-tcomplex]"),
      mapTcomplex = tcomplex.find("[data-map-tcomplex]"),
      innerMap = $("[data-map-inner-tcomplex]"),
      heightMap = $(window).height() - $("[data-header]").height(),
      minHeightMap = heightMap >= 560 ? minHeightMap : 560,
      heightHeader = $("[data-header]").outerHeight(),
      $topBanner = $("[data-top-head-banner]"),
      heightTopBanner = $topBanner.length ? $topBanner.outerHeight() : 0,
      it = this;

    $("[data-conference-halls-tcomplex]").removeClass("active");

    $("[data-filter-tcomplex]").removeAttr("style");
    // Устанавливаем для карты высоту, на момент закрытия попапа, чтобы высота у нас не дёргалась
    innerMap.removeAttr("style").height(minHeightMap);
    tcomplex.removeClass("open-popup").removeClass("show-active-pavilion");

    mapTcomplex.panzoom("setMatrix", [
      currMaxrix[1],
      0,
      0,
      currMaxrix[4],
      currMaxrix[5],
      currMaxrix[6]
    ]);

    popup.stop().animate(
      {
        "margin-top":
          $(window).outerHeight() * 0.55 - (heightHeader + heightTopBanner) / 2,
        "margin-left": "-50px",
        opacity: "0"
      },
      300,
      function() {
        innerMap.removeAttr("style");
        tcomplex.removeClass("animate");

        popup.css("display", "none");
        it.clearActivePavilion();
      }
    );
  };

  this.clearActivePavilion = function() {
    $('[id*="pavilion-"][id*="level-"]').removeClass("active");
    $('[id*="pav-"][id*="level-"][id*="-hover"]').removeClass("open-popup");
    $('[id*="pav-"][id*="level-"][id*="hall-"]').removeClass("active");
  };

  this.initPanzoom = function() {
    let mapWrap = $("[data-map-wrap-tcomplex]"),
      map = mapWrap.find("[data-map-tcomplex]"),
      _duration = 300;

    map.panzoom({
      contain: "invert",
      increment: 1,
      exponential: false,
      minScale: 1,
      maxScale: 8,
      rangeStep: 1,
      duration: _duration,
      easing: "linear"
    });

    mapWrap.on("mousewheel DOMMouseScroll", function(e) {
      if (!$("[data-wrap-map-exhibition-detail-tcomplex]").length) {
        let deltaMouse = !!e.originalEvent.wheelDelta
          ? e.originalEvent.wheelDelta
          : -e.detail;

        e.preventDefault();

        var coordsDesktop = {
          X: e.pageX,
          Y: e.pageY - mapWrap.offset().top
        };

        if (deltaMouse < 0) {
          map.panzoom("zoom", true, {
            offsetVisibleAreaDescktop: true,
            setPositionCenter: true,
            coordsMouseDesktop: coordsDesktop,
            isOutZoom: true // направление зумирования
          });
        } else {
          map.panzoom("zoom", false, {
            offsetVisibleAreaDescktop: true,
            setPositionCenter: true,
            coordsMouseDesktop: coordsDesktop,
            isOutZoom: false // направление зумирования
          });
        }
      }
    });

    map.on("panzoomzoom", function(e, panzoom, matrix, changed) {
      clearTimeout(clearTimeIcons);

      clearTimeIcons = setTimeout(function() {
        var step = (globalScale - 1)*2/7,
         currScale = globalScale - step*(panzoom.scale - 1);

        var stepText = (globalScaleText - 1)*2/7,
         currScaleText = globalScaleText - stepText*(panzoom.scale - 1);

        it.setSizeIcons(currScale, panzoom.scale);
        it.setSizeText(currScaleText, panzoom.scale);
      }, 500);
    });

    // На странице календаря для мобилки и планшета блокируем плагин карты, если доскроллили до границы
    let wrapMapExhibitionDetailTcomplex = $(
      "[data-wrap-map-exhibition-detail-tcomplex]"
    );
    if (wrapMapExhibitionDetailTcomplex.length) {
      var lastY, deltaTouch;

      map.on("touchstart", function(e) {
        map.panzoom("enable");

        if (Media.detect().isMobile || Media.detect().isTablet) {
          // На начало тача запоминаем позицию по Y
          lastY = e.originalEvent.touches[0].clientY;
        }
      });

      map.on("touchmove", function(e) {
        if (Media.detect().isMobile || Media.detect().isTablet) {
          // Определяем в какую сторону скроллим
          deltaTouch = e.originalEvent.touches[0].clientY - lastY;

          var size = document
              .querySelector("[data-map-tcomplex]")
              .getBoundingClientRect(),
            // Определяем расстояние на которое по максимуму можно подвинуть карту внутри блока
            absDeltaMap = Math.round(
              (size.height - $("[data-map-inner-tcomplex]").outerHeight()) / 2
            ),
            _matrix = map.panzoom("getMatrix"),
            scale = Math.round(parseFloat(_matrix[0])),
            deltaMap = deltaTouch > 0 ? absDeltaMap : -absDeltaMap,
            matrixOffsetY = Math.round(parseFloat(_matrix[5]));

          // Если мы доскроллили карту до упора и продолжаем скроллить в ту же сторону - блокируем panzoom и тогда срабатывает скролл страницы
          // Либо если карта находится без зума
          if (
            deltaMap === matrixOffsetY &&
            (scale !== 1 || (scale === 1 && e.touches.length < 2))
          ) {
            map.panzoom("disable");
          } else {
            map.panzoom("enable");
          }
        }
      });
    }
  };

  this.setInitialLocation = function() {
    let hash = window.location.hash;

    if (hash) {
      let hashObj = this.getObjFromHash(hash);

      if (hashObj.pavilion && !hashObj.conference_hall && !hashObj.adv_construction) {
        var level = hashObj["level"] ? ('[id*="level-' + hashObj["level"] + '"]') : '';
        this.ajaxPavilion($('[id*="pavilion-' + hashObj["pavilion"] + '"]' + level));
      }

      if (hashObj.category) {
        if (hashObj.category && hashObj.subcategory) {
          let fBtnParent = $(
            '[data-item-category-tcomplex="' + hashObj["category"] + '"]'
          )[0];

          $('[id*="filter_category-' + hashObj.category + '"]').removeClass(
            "active"
          );

          it.setActiveCategoryFilter(
              $($(fBtnParent).find(".item-category-tcomplex__title")[0]),
              false
            );
          hashObj.subcategory.forEach(function(sub, s) {
            it.showSubcategory(fBtnParent, sub);

            if (sub === 'assembly_gate') {
              $('[data-icon-tooltip-tcomplex="pedestrian_entrances"]').hide()
            }

            $('[data-type-subcategory-tcomplex="' + sub + '"]').addClass('active')
          });

          if(hashObj.adv_construction) {
            let advertisingConstructions = $('[data-advertising-constructions-tcomplex="' + hashObj.adv_construction + '"]');
            it.ajaxAdvertisingConstructions(advertisingConstructions);
          }
        } else if (hashObj.category && !hashObj.subcategory && !hashObj.adv_construction) {
          let fBtn = $(
            '[data-item-category-tcomplex="' + hashObj.category + '"]'
          ).find(".item-category-tcomplex__title")[0];

          this.setActiveCategoryFilter($(fBtn));
          if (hashObj.conference_hall) {
            let currEl = $('#' + hashObj.conference_hall);

            this.ajaxConferenceHalls(currEl.first());
          }
        }
      }
    }
  };

  this.eventMapInit = function () {
    // Настраиваем карту на деталке мероприятия
    let wrapMapExhibitionDetailTcomplex = $('[data-wrap-map-exhibition-detail-tcomplex]');
    if(wrapMapExhibitionDetailTcomplex.length) {

        // Позиционируем карту при загрузке
        let tcomplex = $('[data-tcomplex]'),
            mapTcomplex = tcomplex.find('[data-map-tcomplex]'),
            exhibitionDetailTcomplex = wrapMapExhibitionDetailTcomplex.find('[data-pavilion-exhibition-detail-tcomplex]'),
            isAllPAvilion = (exhibitionDetailTcomplex.data('pavilion-exhibition-detail-tcomplex') == 'all') ? true : false,
            levels = [];

        if(exhibitionDetailTcomplex.length && !isAllPAvilion){
            var selectorEl = '[id*="pavilion-' + exhibitionDetailTcomplex.data('pavilion-exhibition-detail-tcomplex') + '"]';
            it.setPositionMap(tcomplex, mapTcomplex, selectorEl);
        }else{
            tcomplex.addClass('show');
        }

        if(isAllPAvilion) {
          $('[id*="pavilion-"]').addClass('active-exhibition');
        }else {
          let currPavilions = $('[data-active-pav-exhibition-detail-tcomplex]').data('active-pav-exhibition-detail-tcomplex');
          $.each(currPavilions, function(key,value) {
              $('[id*="pavilion-' + value.id + '"]').addClass('active-exhibition');

              // Перебираем все павильоны у которых есть залы с уровнем
              // и записываем в массив уникальные уровни
              if(value.halls){
                 $.each(value.halls, function(key,value) {
                  if($.inArray(value.level, levels) == -1) {
                    levels.push(value.level);
                  }
                });
              }
          });
        }

        // Если в массиве с уровнями только один уровень и он не равен текущему - переключаем на тот, что в массиве
        if((levels.length == 1) && ($('[data-item-level-tcomplex].active').data('item-level-tcomplex') != levels[0])) {
          it.switchLevel(levels[0]);
        }

        $('[data-link-exhibition-detail-tcomplex]').on('click', function(){
            let _this = $(this),
                currPav = _this.data('pavilion-link-exhibition-detail-tcomplex'),
                currHall = _this.data('hall-link-exhibition-detail-tcomplex'),
                currHallsInPav = _this.data('halls-list-exhibition-detail-tcomplex'),
                mapTcomplex = tcomplex.find('[data-map-tcomplex]'),
                numberActiveLevel = $('[data-item-level-tcomplex].active').data('item-level-tcomplex');

            $('[id*="pav-"][id*="level-"]').removeClass('active');

            if(currHall){
                // Если сработал клик на зал
                var currHallMap = $('[id*="pav-'+currPav+'"][id*="hall-'+currHall+'"]');

                if(currHallMap.length) {
                    // Определяем уровень numberLevel, на котором находится зал укзанного павильона
                    var arrHallId = currHallMap.attr('id').split('-'),
                        indexIdInArr = $.inArray("level", arrHallId),
                        numberLevel = arrHallId[indexIdInArr + 1];

                    // Если уровень не равен текущему (активному), то переключаем на найденный numberLevel
                    if(numberActiveLevel != numberLevel) {
                        it.switchLevel(numberLevel);
                    }

                    var selectorEl = '[id*="pavilion-' + currPav + '"][id*="level-' + numberLevel + '"]';

                    // Подсвечиваем текущий зал
                    it.setActiveHall(currHall, currPav, numberLevel);
                    // Позиционируем карту относительно найденного зала
                    it.setPositionMap(tcomplex, mapTcomplex, selectorEl);
                }
            }else{
                // Если сработал клик на павильон

                // Если это кнопка Все павильоны, то подсвечиваем все павильоны и сбрасываем зумирование на 1
                if(currPav == 'all') {
                    $('[id*="pavilion-"] [id*="pav-"][id*="hover"]').addClass('active');
                    $('[id*="pavilion-"] [id*="pav-"][id*="hall-"]').addClass('active');
                    mapTcomplex.panzoom("setMatrix", [1, 0, 0, 1, 0, 0], {offsetVisibleAreaDescktop: true});
                }else {
                    if(currHallsInPav) {
                        // Если сработал клик на павильон в котором выбраны НЕ ВСЕ залы

                        // Есть ли залы на текущем уровне
                        var isCurrLevel = false,
                            numberLevelOther;

                        // Очищаем все выбранные залы
                        $('[id*="pav-"][id*="level-"][id*="hall-"]').removeClass('active');

                        // Заполняем массив выбранных залов для текущего павильона
                        var arrHallsId = [];
                        if(currHallsInPav.toString().indexOf(',') > 0) {
                            arrHallsId = currHallsInPav.split(',');
                        }else{
                            arrHallsId.push(currHallsInPav.toString());
                        }

                        // Подсвечиваем выбранные залы в текущем павильоне
                        arrHallsId.forEach(function(element) {
                            var currHallMap = $('[id*="pav-'+currPav+'"][id*="hall-'+element+'"]');

                            if(currHallMap.length) {
                                // Определяем уровень numberLevel, на котором находится зал укзанного павильона
                                var arrHallId = currHallMap.attr('id').split('-'),
                                    indexIdInArr = $.inArray("level", arrHallId),
                                    numberLevel = arrHallId[indexIdInArr + 1];

                                if(numberActiveLevel == numberLevel) {
                                    isCurrLevel = true;
                                }else{
                                    numberLevelOther = numberLevel;
                                }

                                // Подсвечиваем текущий зал
                                $('[id*="pav-' + currPav + '"][id*="level-' + numberLevel + '"][id*="hall-' + element + '"]').addClass('active');
                            }
                        });

                        if(!isCurrLevel) {
                            numberActiveLevel = numberLevelOther;
                            it.switchLevel(numberActiveLevel);
                        }

                        var selectorEl = '[id*="pavilion-' + currPav + '"][id*="level-' + numberActiveLevel + '"]';
                        // Позиционируем карту на текущий павильон
                        it.setPositionMap(tcomplex, mapTcomplex, selectorEl);
                    }else{
                        // Если сработал клик на павильон в котором выбраны ВСЕ залы

                        $('[id*="pav-' + currPav + '"][id*="hover"]').each(function(i,elem) {
                            // Подсвечиваем все павильоны с текущим номером (на обоих уровнях)
                            var pav = $(this);
                            if(pav.length) pav.addClass('active');
                        });
                        // Подсвечиваем все залы
                        $('[id*="pav-' + currPav + '"][id*="hall-"]').addClass('active');

                        // Если на текущем уровне нет ховера для указанного павильона, то определяем уровень на котором этот
                        // павильон есть и переключаемся на него
                        if(!$('[id*="pav-' + currPav + '"][id*="level-' + numberActiveLevel + '"]').length) {
                            var currPavMap = $('[id*="pav-'+currPav+'"]').first(),
                                arrPavId = currPavMap.attr('id').split('-'),
                                indexIdInArr = $.inArray("level", arrPavId),
                                numberLevel = arrPavId[indexIdInArr + 1];

                            it.switchLevel(numberLevel);
                            numberActiveLevel = numberLevel;
                        }

                        var selectorEl = '[id*="pavilion-' + currPav + '"][id*="level-' + numberActiveLevel + '"]';

                        // Позиционируем карту на текущий павильон
                        it.setPositionMap(tcomplex, mapTcomplex, selectorEl);
                    }
                }
            }
        });

        // Обрабатываем кнопку Показать на схеме. Для неё на обоих уровнях подсвечиваем указанные в деталке павильоны
        $('[data-show-on-map-exhibition-detail-tcomplex]').on('click', function(){
            let _this = $(this),
                strPavilions = _this.data('show-on-map-exhibition-detail-tcomplex'),
                numberActiveLevel = $('[data-item-level-tcomplex].active').data('item-level-tcomplex');

            // Очищаем подсветку для всех павильонов
            $('[id*="pav-"][id*="level-"]').removeClass('active');
            // Очищаем все выбранные залы
            $('[id*="pav-"][id*="level-"][id*="hall-"]').removeClass('active');

            // Устанавливаем для карты единичный масштаб
            mapTcomplex.panzoom("setMatrix", [1, 0, 0, 1, 0, 0], {offsetVisibleAreaDescktop: true});

            $.each(strPavilions, function(key,value) {
                var pav = value.id;

                if(value.halls){
                    $.each(value.halls, function(key,value) {
                        $('[id*="pav-' + pav + '"][id*="level-' + value.level + '"][id*="hall-' + value.id + '"]').addClass('active');
                    });
                }else{
                    // Если у павильона не выбраны залы, полностью подсвечиваем павильон
                    $('[id*="pav-' + pav + '"][id*="hover"]').each(function(i,elem) {
                        var el = $(this);
                        if(el.length) el.addClass('active');
                    });
                    $('[id*="pav-' + pav + '"][id*="hall-"]').addClass('active');
                }
            });
        });
    }
  }

  this.showTooltip = function(curr) {
    let nameCurrIcon = curr.data('icon-tooltip-tcomplex'),
        currId = curr.attr('id'),
        mapTcomplex = $('[data-map-wrap-tcomplex]'),
        map = mapTcomplex.find('[data-map-tcomplex]');

    let tooltip = map.find('[data-tooltip-tcomplex="' + nameCurrIcon + '"]');

    if(tooltip.length) {
      // Скрываем подсказки для всех иконок
      $('[data-tooltip-tcomplex]').removeClass('active');

      // Определяем исходный размер свгшки
      var svgViewbox = map.find('svg').attr('viewBox').split(' ');

      // Вычисляем дробные отношения по X и по Y и определяем максимальное.
      var fractionalRatioX = svgViewbox[2]/mapTcomplex.find('[data-map-inner-tcomplex]').width(),
          fractionalRatioY = svgViewbox[3]/mapTcomplex.find('[data-map-inner-tcomplex]').height(),
          maxFractionalRatio = Math.max(fractionalRatioX, fractionalRatioY);

      // Размеры текущего тултипа
      var tooltipSize = document.querySelector('[data-tooltip-tcomplex="' + nameCurrIcon + '"]').getBoundingClientRect();
      // Получаем высоту тултипа без масштабирования
      var heightTooltipNoScale = tooltipSize.height/map.panzoom('getMatrix')[0];
      // Реальная высота тултипа есть произведение высоты тултипа в координатах карты без масштабирования
      // на масштабирование svg относительно экрана (не путать со scale, задаваемым пользователем)
      var resultHeightTooltip = maxFractionalRatio*heightTooltipNoScale;


      // Текущая иконка
      var iconJs = document.querySelector('[data-icon-tooltip-tcomplex="' + nameCurrIcon + '"][id="' + currId + '"]');
      // Получаем ширину иконки без масштабирования
      var widthIconNoScale = iconJs.getBoundingClientRect().width/map.panzoom('getMatrix')[0];
      // Реальная ширина иконки есть произведение ширины иконки в координатах карты без масштабирования
      // на масштабирование svg относительно экрана (не путать со scale, задаваемым пользователем)
      var resultWidthIcon = maxFractionalRatio*widthIconNoScale;


      // Размеры тултипа без текста, с помощью которого определяем смещение стрелки снизу относительно левого края
      var tooltipHidden = document.querySelector('[data-tooltip-tcomplex="hidden_without_text"]').getBoundingClientRect();
      // Ширина от левого края до носика стрелочки с учётом масштаба
      var arrLeftWidthIcon = maxFractionalRatio*(tooltipHidden.width/2)/map.panzoom('getMatrix')[0];


      // Позиционируем тултип
      tooltip.attr('transform', 'matrix(1 0 0 1 ' + (parseFloat(curr.attr('x')) + resultWidthIcon/2 - arrLeftWidthIcon) + ' ' + (parseFloat(curr.attr('y')) - resultHeightTooltip) + ')');

      // Отображаем подсказку для текущей иконки
      tooltip.addClass('active');
    }
  },

  this.setSizeIcons = function(scale, panzoomScale){
    var elIcons = document.querySelectorAll('[data-icons-map-tcomplex]');

    scale = (scale <= minScaleIcons) ? minScaleIcons : scale;
    for (var i = 0; i < elIcons.length; i++) {

      var _item = elIcons[i],
        $item = $(_item),
        oldMatrix = $item.css('transform').split(/[\s,\(\))]+/),
        oldScale = !!oldMatrix[1] ? parseFloat(oldMatrix[1]) : 1;

      if(oldScale != scale) {
        $item.attr('transform', 'matrix(1, 0, 0, 1, 0, 0)');

        var paramsItem = _item.getBoundingClientRect(),
          deltaX = (1-scale)*paramsItem.width/(2*panzoomScale),
          deltaY = (1-scale)*paramsItem.height/(2*panzoomScale);

        $item.attr('transform', 'matrix(' + scale + ', 0, 0, '+ scale +', ' + deltaX + ', ' + deltaY + ')');
      }
    }
  }

  this.setSizeText = function(scale, panzoomScale){
    var elText = document.querySelectorAll('[data-name-pavilion]');

    scale = (scale <= 1) ? 1 : scale;

    for (var i = 0; i < elText.length; i++) {
      var _item = elText[i],
          $item = $(_item);

      $item.attr('transform', 'matrix(1, 0, 0, 1, 0, 0)');

      var paramsItem = _item.getBoundingClientRect(),
          positionX = (1-scale)*parseFloat($item.data('x-name-pav')),
          positionY = (1-scale)*parseFloat($item.data('y-name-pav'));
      $item.attr('transform', 'matrix(' + scale + ', 0, 0, '+ scale +', ' + positionX + ', ' + positionY + ')');

      var paramsItemNew = _item.getBoundingClientRect(),
      deltaX = (paramsItemNew.width - paramsItem.width)*scale/(2*panzoomScale);

      $item.attr('transform', 'matrix(' + scale + ', 0, 0, '+ scale +', ' + (positionX - deltaX) + ', ' + positionY + ')');
      $item.animate({ opacity: 1 }, 200);
    }
  }

  this.initSelectizePanel = function($select, nameWrap, callback) {
    callback = callback || false;

    $select.selectize({
        onInitialize: function (value) {
            this.$dropdown.css('visibility', 'hidden').css('opacity', '0');
        },
        onChange: function(value){
            var elem = this.$input[0],
                container = $(elem).closest('[' + nameWrap + ']');

            // fix бага selectize с выбранным элементом
            container.find('.option').removeClass('selected');
            container.find('[data-value="'+value+'"].option').addClass('selected');

            callback(value);
        },
        onDropdownOpen: function (dropdown) {
            var self = this;

            $(dropdown)
              .css('width', this.$control[0].offsetWidth + 'px')
              .css('top', this.$control[0].offsetHeight + 'px')
              .css('visibility', 'visible')
              .css('opacity', '1');

            $(dropdown).addClass('has-scrollbar');
            $(dropdown).find('.selectize-dropdown-content').addClass('nano-content');

            setTimeout(function(){
                $(dropdown).nanoScroller({scroll: 'top'});
                self.$dropdown[0].nanoscroller.reset();
            }, 100);
        },
        onDropdownClose: function (dropdown) {
            $(dropdown).css('visibility', 'hidden').css('opacity', '0');

            setTimeout(function () {
                $(dropdown).prev().find('input').blur();
            }, 250);
        }
    });
  }

  this.setActiveElementsPanel = function(objHashStr, idPav, idConferenceHall, noUpdateUrl) {
    let $filterPanel = $('[data-filter-panel-tcomplex]'),
        objHash = it.getObjFromHash(objHashStr),        
        $selectizeHall = $filterPanel.find('[data-select-hall-filter-panel]')[0].selectize,
        $wrapMobileSelectizePavilion = $('[data-select-pavilion-wrap-filter-panel]'),
        $mobileSelectizePavilion = $('[data-select-pavilion-filter-panel]')[0].selectize,
        numPavilion;

    if(idPav) {
      numPavilion = idPav;

      if(idConferenceHall) {
        var currLevel = 2;
        if(objHash['level'] && objHash['level'][0]) {
          currLevel = objHash['level'][0];
        }
        objHashStr = '#category=conference_halls#conference_hall=' + objHash['conference_hall'][0] + '#item_conference_halls='+ idConferenceHall +'#level=' + currLevel;
      }
    }else{
      if(objHash['pavilion']) {
        numPavilion = objHash['pavilion'][0];
      }
    }

    let $currPavilionPanel = $filterPanel.find('[data-number-pavilion="'+ numPavilion +'"]'),
        listHalls = $currPavilionPanel.data('halls-panel-tcomplex'),
        listConferenceHalls = $currPavilionPanel.data('conference-halls-panel-tcomplex');

    $selectizeHall.disable();
    $selectizeHall.clearCache('option');
    $selectizeHall.clearOptions();

    $filterPanel.find('[data-number-pavilion]').removeClass('active');
    $currPavilionPanel.addClass('active');

    if($mobileSelectizePavilion) {
      $wrapMobileSelectizePavilion.find('.option').removeClass('selected');
      $mobileSelectizePavilion.setValue(numPavilion, true);
    }

    if(listHalls || listConferenceHalls) {
      $selectizeHall.addOptionGroup('hall', {label: 'Hall'});
      listHalls.forEach(function(item, i) {
        $selectizeHall.addOption({value: item.id, text: item.name, optgroup: 'hall'});
      });

      if(listConferenceHalls) {
        $selectizeHall.addOptionGroup('conference', {label: 'Conference'});

        listConferenceHalls.forEach(function(item, i) {
          $selectizeHall.addOption({value: item.id, text: item.name, optgroup: 'conference'});
        });
      }

      $selectizeHall.refreshOptions(true);
      $selectizeHall.enable();

      if(noUpdateUrl){
        isUpdateValueSelectizePanel = false;
      }

      $selectizeHall.setValue(objHashStr);

    }else{
      $selectizeHall.addOption({value: '', text: ''});
      $selectizeHall.refreshOptions(true);
    }

    $filterPanel.find('[data-clear-pavilion-panel-tcomplex]').addClass('active');
  }

  this.clearPavilionAndHallPanel = function(isResetUrl){
    // Очищаем список залов
      var $panel = $('[data-filter-panel-tcomplex]'),
          $selectizeHall = $panel.find('[data-select-hall-filter-panel]')[0].selectize;

      $selectizeHall.disable();
      $selectizeHall.clearCache('option');
      $selectizeHall.clearOptions();
      $selectizeHall.addOption({value: '', text: ''});
      $selectizeHall.refreshOptions(true);

      if(Media.detect().isMobile) {
        var $option = $('[data-select-wrap-pavilion-filter-panel]').find('.option');

        //$option.removeClass('selected');
        $option.removeClass('active');
        $panel.find('[data-select-pavilion-filter-panel]')[0].selectize.clear();
      }

      //Очищаем выбранные павильоны
      $panel.find('[data-number-pavilion]').removeClass('active');
      if(isResetUrl) {
        window.location.hash = "";
      }

      // Скрываем кнопку очищения
      $('[data-clear-pavilion-panel-tcomplex]').removeClass('active');
  }

  this.clearSearch = function(){
    let $filterPanel = $('[data-filter-panel-tcomplex]');

    $filterPanel.find('[data-clear-search-filter-panel-map]').removeClass('show');
    $filterPanel.find('[data-live-search-input]').val('');
    $filterPanel.find('[data-live-search-result]').hide().empty();
    $filterPanel.find('[data-btn-search-filter-panel-map]').show();
  }

  this.initFilterPanel = function() {
    let $filterPanel = $('[data-filter-panel-tcomplex]');
    if($filterPanel.length) {

      let $selectizeHall = $filterPanel.find('[data-select-hall-filter-panel]'),
        $selectizePavilion = $filterPanel.find('[data-select-pavilion-filter-panel]');

      // Инициализируем селектиз для залов и блокируем его
      if($selectizeHall.length) {
        it.initSelectizePanel($selectizeHall, 'data-select-hall-wrap-filter-panel', function(value){
          var idPav = $filterPanel.find('[data-number-pavilion].active').data('number-pavilion');
            if(!!value) {
              var objHash = it.getObjFromHash(window.location.hash),
                  category = objHash['category'] ? '#category=' + objHash['category'][0] : '';

              if(isUpdateValueSelectizePanel) {
                it.setHash(value);
              }

              isUpdateValueSelectizePanel = true;
            }
        });

        $selectizeHall[0].selectize.disable();
      }

      // Устанавливаем хэш по клику на павильоны в панеле фильтра
      $filterPanel.on('click', '[data-number-pavilion]', function(e){
        e.preventDefault();
        e.stopPropagation();

        let $this = $(this);

        if(!$this.hasClass('active')) {
          let idPav = $this.data('number-pavilion'),
              listHalls = $this.data('halls-panel-tcomplex'),
              listConferenceHalls = $this.data('conference-halls-panel-tcomplex'),
              level = $this.data('level-panel-tcomplex'),
              objHash = it.getObjFromHash(window.location.hash);

          if(listHalls) {
            it.setHash(listHalls[0].id);

            if(!listHalls && listConferenceHalls) {
              it.setHash(listConferenceHalls[0].id);
            }
          }else{
            var levelUrl =  level? 
                          ('#level=' + level) : 
                          ('#level=' + $('[data-item-level-tcomplex].active').data('item-level-tcomplex'));

            it.setHash('#pavilion=' + idPav + levelUrl);
          }
        }
      });

      // Инициализируем селектиз для павильонов
      if($selectizePavilion.length) {
        it.initSelectizePanel($selectizePavilion, 'data-select-pavilion-wrap-filter-panel', function(value){

          let $listPavilion = $('[data-list-pavilion-panel-tcomplex]'),
              $currPav = $listPavilion.find('[data-number-pavilion="'+ value +'"]'),
              idPav = $currPav.data('number-pavilion'),
              listHalls = $currPav.data('halls-panel-tcomplex'),
              listConferenceHalls = $currPav.data('conference-halls-panel-tcomplex'),
              level = $currPav.data('level-panel-tcomplex');

          if(listHalls) {
            it.setHash(listHalls[0].id);

            if(!listHalls && listConferenceHalls) {
              it.setHash(listConferenceHalls[0].id);
            }
          }else{
            var levelUrl =  level? 
                          ('#level=' + level) : 
                          ('#level=' + $('[data-item-level-tcomplex].active').data('item-level-tcomplex'));

            it.setHash('#pavilion=' + idPav + levelUrl);
          }
        });
      }

      // По крестику очищаем поля павильонов и залов
      $filterPanel.on('click', '[data-clear-pavilion-panel-tcomplex]', function(){
        it.clearPavilionAndHallPanel(true);
      });

      // Ввод в поле поиска в панели фильтра
      $filterPanel.on('input', '[data-live-search-input]', function(){
        let currVal = $(this).val();

        if(currVal.length >= 3) {
          $filterPanel.find('[data-clear-search-filter-panel-map]').addClass('show');
          $filterPanel.find('[data-btn-search-filter-panel-map]').hide();
        }

        if(currVal.length == 0) {
          it.clearSearch();
        }
      });
      
      // По крестику очищаем поле поиска в панели фильтра
      $filterPanel.on('click', '[data-clear-search-filter-panel-map]', function(){
        it.clearSearch();
      });

      $filterPanel.on('click', '[data-btn-search-filter-panel-map]', function(){
        let $this = $(this),
            $search = $this.closest('[data-search-filter-panel-map]'),
            $input = $search.find('[data-input-search-filter-panel-map]');

        if(Media.detect().isTablet || Media.detect().isMobile) {

          if($filterPanel.hasClass('active-search')) {

            $search.stop().animate({ width: "32px" }, 500, function(){
              $search.removeAttr('style');
              $filterPanel.removeClass('active-search');
              $input.hide();
            });
            
          }else{
            $filterPanel.addClass('active-search');
            $search.stop().animate({ width: "100%" }, 500, function(){
              $input.show();
            });
          }
        }
      });

      $(window).on('mdbreakpoint', function(e, breakpointOld, breakpointOldNew) {
        if(((breakpointOld == 'isTablet' || breakpointOld == 'isMobile')&&(breakpointOldNew == 'isDesktop' || breakpointOldNew == 'isDesktopHD')) ||
          ((breakpointOld == 'isDesktop' || breakpointOld == 'isDesktopHD')&&(breakpointOldNew == 'isTablet' || breakpointOldNew == 'isMobile'))) {

          $('[data-search-filter-panel-map]').removeAttr('style');
          $('[data-input-search-filter-panel-map]').removeAttr('style').val('');
          it.clearSearch();
          $('[data-filter-panel-tcomplex]').removeClass('active-search');
        }
      });
    }
  }

  this.init = function() {
    this.initPanzoom();
    this.initFilterPanel();
    this.clickEvents();
    this.hoverEvents();
    this.hashChangeEvent();

    this.setInitialLocation();
    this.eventMapInit();
    this.setSizeIcons(globalScale, 1);
    this.setSizeText(globalScaleText, 1);
  };
};

window.addEventListener("load", function() {
  let tcomplex = $('[data-tcomplex]');
  if(tcomplex.length){
    let nav = new mapNav();

    nav.init();
  }

  if($('body').hasClass('tcomplex-page')) {
      let footer = $('[data-footer]'),
          footerHeight = footer.outerHeight(),
          bottomFooter = -footerHeight + 26; // где 26 - высота виднеющейся полоски футера

      footer.css({
          'top': 'auto',
          'bottom': bottomFooter + 'px'
      });

      footer.hover(function(){
          if(!window.mousedownMap) {
              $(this).stop().animate({ bottom: 0 }, 300);
          }
      }, function(){
          $(this).stop().animate({ bottom: bottomFooter + 'px' }, 300);
      });
  }
});


// WEBPACK FOOTER //
// ./components/territory-complex.js